import React from "react";
import { Link } from "react-router-dom";

const HomeHero = () => {
  return (
    <section className="pt-6 md:pt-12 pb-8 relative">
      <div className="flex flex-col items-center text-center space-y-4">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight leading-tight font-mono text-center">
          Build <span className="text-[#ff5733]">Reliable Agents</span> With RL
        </h1>
        <p className="text-lg text-muted-foreground max-w-3xl font-mono">
          Reinforcement learning helps your agent learn from experience to
          achieve <strong>higher reliability</strong>,{" "}
          <strong>lower latency</strong>, and <strong>lower costs</strong>.
        </p>

        <div className="flex flex-col sm:flex-row w-full max-w-md justify-center gap-4 pt-8">
          <a
            href="https://github.com/OpenPipe/ART"
            target="_blank"
            rel="noopener noreferrer"
            className="w-auto"
          >
            <button className="px-6 py-3 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors w-auto">
              Use open source
            </button>
          </a>
          <Link to="/book-demo" className="w-auto">
            <button className="px-6 py-3 bg-secondary text-foreground rounded-lg font-medium hover:bg-secondary/80 transition-colors w-auto">
              Book a demo
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
